const MuiBadge = {
  variants: [
    {
      props: { variant: "boxy" },
      style: {
        ".MuiBadge-badge": {
          borderRadius: "4px",
          padding: "0 4px",
          minWidth: "unset"
        }
      }
    }
  ],
  styleOverrides: {
    badge: ({ ownerState, theme }) => {
      const hasChildren = Boolean(ownerState.children);
      return {
        boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
        ...!hasChildren && {
          position: "unset",
          top: "unset",
          right: "unset",
          transform: "unset"
        }
      };
    }
  }
};
export {
  MuiBadge
};
//# sourceMappingURL=MuiBadge.js.map
